import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const IMTitleContainer = styled(Box).attrs({
  width: '100%',
  direction: 'column',
})``;

export const IntegrationManagementWrapper = styled(Box).attrs({
  width: '100%',
})``;

export const Title = styled(Text).attrs({
  size: 'header',
  fontWeight: 'bold',
  color: 'primaryText',
})``;

export const Subtitle = styled(Title).attrs({
  fontWeight: 'regular',
})``;

export const IconWrapper = styled(Box).attrs(() => {})`
  cursor: pointer;
  &:hover {
    background-color: ${({ clickable, theme }) =>
      clickable ? theme.colors.lightLineDivider : 'unset'};
  }
`;
